import React from 'react';
import PropTypes from 'prop-types';

import session from 'services/sessionService';
import events from 'lib/events';

class AdminOnly extends React.Component {
  static propTypes = {
    children: PropTypes.any,
  };

  componentWillMount() {
    this.sub = events.subscribe('userset', user => {
      this.setState({user});
    });

    this.setState({user: session.getUser()});
  }

  componentWillUnmount() {
    this.sub.remove();
  }

  render() {
    if (!this.state.user || !this.state.user.isAdmin) {
      return null;
    }

    return <div>{this.props.children}</div>;
  }
}

export default AdminOnly;
